import React from "react";
import { Row, Col, Input, FormFeedback, Button } from "reactstrap";
import { PulseLoader } from "react-spinners";
import { serviceCaller } from "../../../../composition";
import styles from "./styles.scss";
import withStyles from "isomorphic-style-loader/withStyles";
import { Props } from "./types";

const ApiKeyInput = ({
  setApiKeyValue,
  setCanConnect,
  setIsValid,
  setFeedback,
  onConnectKey,
  isValid,
  isConnected,
  isLoading,
  feedback,
  apiKeyValue,
  canConnect,
  connectButtonLabel = "Connect",
  inputType = "text",
}: Props) => {
  const checkValidKey = () => {
    if (!!!apiKeyValue || apiKeyValue.length < 10) {
      setCanConnect(false);
      setIsValid(false);
      setFeedback("API Key must be at least 10 characters long");
      return;
    }

    setCanConnect(true);
    setIsValid(undefined);
  };
  return (
    <div>
      <Row>
        <Col xs="12">
          <Input
            name="apiKey"
            placeholder="Enter API Key"
            type={inputType}
            autoComplete={inputType === "password" ? "new-password" : "off"}
            onChange={event => setApiKeyValue(event.target.value)}
            onBlur={checkValidKey}
            valid={isValid}
            invalid={isValid !== undefined && !isValid}
            disabled={isConnected || isLoading}
            value={apiKeyValue ? apiKeyValue : ""}
          />
          <FormFeedback
            className={`${styles.formFeedback} ${
              isValid ? styles.successColor : styles.errorColor
            }`}
            valid={isValid}
            invalid={isValid !== undefined && !isValid}
          >
            {isValid ? (
              <span>
                <i className={`fa fa-check-circle`} /> Successfully connected.
              </span>
            ) : (
              <span>
                <i className={`fa fa-close`} /> {feedback}
              </span>
            )}
          </FormFeedback>
        </Col>
      </Row>
      {!isConnected && (
        <Row>
          <Button
            onClick={onConnectKey}
            className={styles.button}
            disabled={!canConnect || isLoading}
            style={{
              marginTop:
                isValid !== undefined && !isValid ? "-12px" : undefined,
            }}
          >
            {isLoading ? (
              <PulseLoader color="#1F65B1" loading={true} />
            ) : (
              connectButtonLabel
            )}
          </Button>
        </Row>
      )}
    </div>
  );
};

export default serviceCaller(withStyles(styles)(ApiKeyInput));
